import React, { useCallback } from 'react';
import PrivateMenuItem from 'components/PrivateMenuItem';
import { Menu } from 'semantic-ui-react';
import {
  CouponsMenu,
  KybReviewMenu,
  NpwpReviewMenu,
  BillingReviewMenu,
  ResetPhoneMenu,
  ForceActivationMenu,
  OutletBulkUpdateExpirationMenu,
  AccessMenu,
  UserMappingMenu,
  BusinessMenu,
  DeleteBusinessMenu,
  RestoreDeletedBusinessMenu,
  DiscountRulesMenu,
  ChangeUserEmailMenu,
  BillingPackagesMenu,
  AdditionalServicesMenu,
  HardwareCataloguesMenu,
  KycContactListMenu,
} from 'constants/session/permissionNames/menu';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from 'state/session/actions';
import { NavLink } from 'react-router-dom';
import styles from './Sidebar.module.css';

const Sidebar = () => {
  const dispatch = useDispatch();
  const currentUser = useSelector(state => state.session.currentUser);
  const onLogoutClick = useCallback(() => dispatch(logout()), [dispatch]);

  return (
    <nav className={styles['sidebar-container']}>
      <div className={styles['logo-container']}>
        <img
          src="assets/images/logo-moka.png"
          width={50}
          height={50}
          alt="Logo"
        />
      </div>
      <div className={styles['menu-divider']} />
      <PrivateMenuItem
        name="Business"
        permissionName={BusinessMenu}
        to="/business"
        activeClassName={styles['nav-active']}
      />
      <PrivateMenuItem
        name="Delete Business"
        permissionName={DeleteBusinessMenu}
        to="/delete-business"
        activeClassName={styles['nav-active']}
      />
      <PrivateMenuItem
        name="Restore Deleted Business"
        permissionName={RestoreDeletedBusinessMenu}
        to="/restore-deleted-business"
        activeClassName={styles['nav-active']}
      />
      <PrivateMenuItem
        name="Discount Rules"
        permissionName={DiscountRulesMenu}
        to="/discount-rules"
        activeClassName={styles['nav-active']}
      />
      <PrivateMenuItem
        name="Coupons"
        permissionName={CouponsMenu}
        to="/coupons"
        activeClassName={styles['nav-active']}
      />
      <PrivateMenuItem
        name="Billing Package"
        permissionName={BillingPackagesMenu}
        to="/billing-packages"
        activeClassName={styles['nav-active']}
      />
      <PrivateMenuItem
        name="Additional Services"
        permissionName={AdditionalServicesMenu}
        to="/additional-services"
      />
      <PrivateMenuItem
        name="Hardware Catalogue"
        permissionName={HardwareCataloguesMenu}
        to="/hardware-catalogues"
        activeClassName={styles['nav-active']}
      />
      <PrivateMenuItem
        name="KYB Review"
        permissionName={KybReviewMenu}
        to="/kyb"
        activeClassName={styles['nav-active']}
      />
      <PrivateMenuItem
        name="KYC Contact List"
        permissionName={KycContactListMenu}
        to="/kyc"
        activeClassName={styles['nav-active']}
      />
      <PrivateMenuItem
        name="NPWP Review"
        permissionName={NpwpReviewMenu}
        to="/npwp"
        activeClassName={styles['nav-active']}
      />
      <PrivateMenuItem
        name="Config"
        permissionName={BillingReviewMenu}
        to="/config"
        activeClassName={styles['nav-active']}
      />
      <PrivateMenuItem
        name="Activation"
        permissionName={ForceActivationMenu}
        to="/activation"
        activeClassName={styles['nav-active']}
      />
      <PrivateMenuItem
        name="Reset Phone Number"
        permissionName={ResetPhoneMenu}
        to="/reset-phone-number"
        activeClassName={styles['nav-active']}
      />
      <PrivateMenuItem
        name="Outlet Expiration Update"
        permissionName={OutletBulkUpdateExpirationMenu}
        to="/outlet-bulk-update-expiration"
        activeClassName={styles['nav-active']}
      />
      <PrivateMenuItem
        name="Change User Email"
        permissionName={ChangeUserEmailMenu}
        to="/change-user-email"
        activeClassName={styles['nav-active']}
      />
      <PrivateMenuItem
        name="Access"
        permissionName={AccessMenu}
        to="/access"
        activeClassName={styles['nav-active']}
      />
      <PrivateMenuItem
        name="User Mapping"
        permissionName={UserMappingMenu}
        to="/user-mapping"
        activeClassName={styles['nav-active']}
      />
      <div className={styles['menu-divider']} />
      <NavLink to="/change-password" activeClassName={styles['nav-active']}>
        Settings
      </NavLink>
      <Menu.Item>{currentUser.username}</Menu.Item>
      <Menu.Item as="button" name="Logout" onClick={onLogoutClick} />
    </nav>
  );
};

export default Sidebar;
